<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" v-bind:href="'#t1'+rowData.veiculo_id+''" role="tab" data-toggle="tab">
                        <span class="nav-link-in">
                            Detalhes
                            <i class="fa fa-plus"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t2'+rowData.veiculo_id+''" role="tab" data-toggle="tab" v-if='rowData.veiculo_seguro.length>0'>
                      <span class="nav-link-in">
                        Seguro
                        <i class="fa fa-shield"></i>
                      </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t3'+rowData.veiculo_id+''" role="tab" data-toggle="tab"v-if='rowData.veiculo_abastecimento.length>0'>
                        <span class="nav-link-in">
                            Abastecimento
                            <i class="fa fa-car"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t4'+rowData.veiculo_id+''" role="tab" data-toggle="tab"v-if='rowData.veiculo_documento.length>0'>
                        <span class="nav-link-in">
                            Documento
                            <i class="fa fa-file"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t5'+rowData.veiculo_id+''" role="tab" data-toggle="tab"v-if='rowData.veiculo_manutencao.length>0'>
                        <span class="nav-link-in">
                            Manutenção
                            <i class="fa fa-wrench"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t6'+rowData.veiculo_id+''" role="tab" data-toggle="tab"v-if='rowData.veiculo_multa.length>0'>
                        <span class="nav-link-in">
                            Multa
                            <i class="fa fa-file-text"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t7'+rowData.veiculo_id+''" role="tab" data-toggle="tab" v-if='rowData.veiculo_pneu.length>0'>
                    <span class="nav-link-in">
                      Pneu
                      <i class="fa fa-dot-circle-o"></i>
                    </span>
                  </a>
                </li>
            </ul>

			<div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.veiculo_id+''">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 10%">Capacidade KG</th>
                                <th style="width: 10%">Capacidade M3</th>
                                <th style="width: 10%">CNPJ/CPF</th>
                                <th style="width: 30%">Razão Social/Nome</th>
                                <th style="width: 20%">Municipio</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{ rowData.capacidade_kg}}
                                </td>
                                <td>
                                    {{ rowData.capacidade_m3}}
                                </td>
                                <td>
                                    <span v-if="rowData.pessoa!==null">
                                       <span v-if="rowData.pessoa.pessoa_juridica!==null">{{ onFormataCnpj(rowData.pessoa.pessoa_juridica.cnpj_base,rowData.pessoa.pessoa_juridica.cnpj_filial,rowData.pessoa.pessoa_juridica.cnpj_digito)}}</span>
                                       <span v-if="rowData.pessoa.pessoa_exterior!==null">{{ rowData.pessoa.pessoa_exterior.cuit }}</span>
                                       <span v-if="rowData.pessoa.pessoa_fisica!==null">{{ rowData.pessoa.pessoa_fisica.cpf }}</span>
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.pessoa!==null">
                                       <span v-if="rowData.pessoa.pessoa_juridica!==null">{{ rowData.pessoa.pessoa_juridica.razao_social }}</span>
                                       <span v-if="rowData.pessoa.pessoa_exterior!==null">{{ rowData.pessoa.pessoa_exterior.nome }}</span>
                                       <span v-if="rowData.pessoa.pessoa_fisica!==null">{{ rowData.pessoa.pessoa_fisica.nome }}</span>
                                    </span>
                                </td>
                                <td>
                                    {{ rowData.municipio.nome}}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 15%">Tipo Veículo</th>
                                <th style="width: 15%">Combustível</th>
                                <th style="width: 15%">Câmbio</th>
                                <th style="width: 15%">Marca</th>
                                <th style="width: 15%">Modelo</th>
                                <th style="width: 15%">Blindado</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.tp_veiculo">
                                        {{ rowData.veiculo_detalhe.tp_veiculo.descr }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.tp_combustivel">
                                        {{ rowData.veiculo_detalhe.tp_combustivel.descr }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.tp_cambio">
                                        {{ rowData.veiculo_detalhe.tp_cambio.descr }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.marca">
                                        {{ rowData.veiculo_detalhe.marca.descr }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.modelo">
                                        {{ rowData.veiculo_detalhe.modelo }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.is_blindado">
                                        {{ rowData.veiculo_detalhe.is_blindado.descr }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 10%">Ano Fabricação</th>
                                <th style="width: 10%">Ano Modelo</th>
                                <th style="width: 10%">Cilindradas</th>
                                <th style="width: 10%">Potência</th>
                                <th style="width: 10%">Chassi</th>
                                <th style="width: 10%">Cor</th>
                                <th style="width: 40%">Observação</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.ano_fabricacao">
                                        {{ rowData.veiculo_detalhe.ano_fabricacao }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.ano_modelo">
                                        {{ rowData.veiculo_detalhe.ano_modelo }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.cilindradas">
                                        {{ rowData.veiculo_detalhe.cilindradas }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.potencia">
                                        {{ rowData.veiculo_detalhe.potencia }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.chassi">
                                        {{ rowData.veiculo_detalhe.chassi }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.cor">
                                        {{ rowData.veiculo_detalhe.cor.descr }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="rowData.veiculo_detalhe.obs">
                                        {{ rowData.veiculo_detalhe.obs }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t2'+rowData.veiculo_id+''" v-if="rowData.veiculo_seguro.length>0">
                <table class="table-striped" id="mais">
                    <thead>
                        <tr>
                          <th data-toggle="true" style="width: 20%">Data de Início</th>
                          <th data-toggle="true" style="width: 20%">Data de Fim</th>
                          <th data-toggle="true" style="width: 20%">Corretora</th>
                          <th data-toggle="true" style="width: 10%">Valor Seguro</th>
                          <th data-toggle="true" style="width: 20%">Seguradora</th>
                          <th data-toggle="true" style="width: 5%">Status</th>
                          <th data-toggle="true" style="width: 5%">Ações</th>
                        </tr>
                     </thead>
                     <tbody>
                         <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_seguro'>
                            <td>
                             <span>{{ formatDate(item.dt_inicio) }}</span>
                            </td>
                            <td>
                                <span>{{ formatDate(item.dt_fim) }}</span>
                            </td>
                            <td>
                             <span>{{ item.corretora }}</span>
                            </td>
                            <td>
                             <span>{{ formatNumber(item.vlr_seguro) }}</span>
                            </td>
                            <td>
                             <span>{{ item.seguradora.nome }}</span>
                            </td>
                            <td>
                                <span class="label label-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                <span class="label label-warning" v-if="item.status.valor==3">{{ item.status.descr }}</span>
                            </td>
                            <td>
                                <a @click="onEditSeguro(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div><!--.tab-pane-->
            <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t3'+rowData.veiculo_id+''" v-if="rowData.veiculo_abastecimento.length>0">
            <table class="table-striped" id="mais">
                <thead>
                    <tr>
                      <th data-toggle="true" style="width: 20%">N° Documento</th>
                      <th data-toggle="true" style="width: 20%">Data de Abastecimento</th>
                      <th data-toggle="true" style="width: 10%">Valor</th>
                      <th data-toggle="true" style="width: 10%">Valor Litro</th>
                      <th data-toggle="true" style="width: 10%">Qtde. Litros</th>
                      <th data-toggle="true" style="width: 10%">Tipo</th>
                      <th data-toggle="true" style="width: 10%">KM Atual</th>
                      <th data-toggle="true" style="width: 5%">Status</th>
                      <th data-toggle="true" style="width: 5%">Ações</th>
                    </tr>
                 </thead>
                 <tbody>
                     <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_abastecimento'>
                        <td>
                         <span>{{ item.num_documento }}</span>
                        </td>
                        <td>
                            <span>{{ formatDate(item.dt_abastecimento) }}</span>
                        </td>
                        <td>
                         <span>{{ formatNumber(item.vlr_doc) }}</span>
                        </td>
                        <td>
                         <span>{{ formatNumber(item.vlr_litro) }}</span>
                        </td>
                        <td>
                         <span>{{ formatNumber(item.qtde_litros) }}</span>
                        </td>
                        <td>
                         <span>{{ item.tp_combustivel.descr }}</span>
                        </td>
                        <td>
                         <span>{{ item.km_atual }}</span>
                        </td>
                        <td>
                            <span class="label label-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                            <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                        </td>
                        <td>
                            <a @click="onEditAbastecimento(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="table-striped" id="mais">
                <thead>
                    <tr>
                        <th style="width: 100%">Observação</th>
                    </tr>
                 </thead>
                 <tbody>
                     <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_abastecimento'>
                        <td>
                            <span>
                                {{ item.obs}}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div><!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t4'+rowData.veiculo_id+''" v-if="rowData.veiculo_documento.length>0">
        <table class="table-striped" id="mais">
            <thead>
                <tr>
                  <th data-toggle="true" style="width: 15%">N° Documento</th>
                  <th data-toggle="true" style="width: 10%">Tipo</th>
                  <th data-toggle="true" style="width: 10%">Valor</th>
                  <th data-toggle="true" style="width: 10%">Parcelas</th>
                  <th data-toggle="true" style="width: 15%">Data Início</th>
                  <th data-toggle="true" style="width: 15%">Data Fim</th>
                  <th data-toggle="true" style="width: 15%">Data Vencimento</th>
                  <th data-toggle="true" style="width: 5%">Status</th>
                  <th data-toggle="true" style="width: 5%">Ações</th>
                </tr>
             </thead>
             <tbody>
                 <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_documento'>
                    <td>
                     <span>{{ item.num_documento }}</span>
                    </td>
                    <td>
                        <span>{{ item.tp_documento.descr }}</span>
                    </td>
                    <td>
                     <span>{{ formatNumber(item.vlr_doc) }}</span>
                    </td>
                    <td>
                     <span>{{ item.parcelas }}</span>
                    </td>
                    <td>
                     <span>{{ formatDate(item.dt_inicio) }}</span>
                    </td>
                    <td>
                        <span>{{ formatDate(item.dt_fim) }}</span>
                    </td>
                    <td>
                        <span>{{ formatDate(item.dt_vencimento) }}</span>
                    </td>
                    <td>
                        <span class="label label-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                        <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                        <span class="label label-warning" v-if="item.status.valor==3">{{ item.status.descr }}</span>
                    </td>
                    <td>
                        <a @click="onEditDocumento(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="table-striped" id="mais">
            <thead>
                <tr>
                    <th style="width: 100%">Observação</th>
                </tr>
             </thead>
             <tbody>
                 <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_documento'>
                    <td>
                        <span>
                            {{ item.obs}}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div><!--.tab-pane-->
            <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t5'+rowData.veiculo_id+''" v-if="rowData.veiculo_manutencao.length>0">
            <table class="table-striped" id="mais">
                <thead>
                    <tr>
                      <th data-toggle="true" style="width: 10%">N° Documento</th>
                      <th data-toggle="true" style="width: 15%">Tipo</th>
                      <th data-toggle="true" style="width: 10%">Valor</th>
                      <th data-toggle="true" style="width: 10%">KM Atual</th>
                      <th data-toggle="true" style="width: 15%">Data Manutenção</th>
                      <th data-toggle="true" style="width: 5%">Status</th>
                      <th data-toggle="true" style="width: 5%">Ações</th>

                    </tr>
                 </thead>
                 <tbody>
                     <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_manutencao'>
                        <td>
                         <span>{{ item.num_documento }}</span>
                        </td>
                        <td>
                            <span>{{ item.tp_manutencao.descr }}</span>
                        </td>
                        <td>
                         <span>{{ formatNumber(item.vlr_manutencao) }}</span>
                        </td>
                        <td>
                         <span>{{ item.km_atual }}</span>
                        </td>
                        <td>
                         <span>{{ formatDate(item.dt_manutencao) }}</span>
                        </td>
                        <td>
                            <span class="label label-info" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                            <span class="label label-warning" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                            <span class="label label-success" v-if="item.status.valor==3">{{ item.status.descr }}</span>
                            <span class="label label-danger" v-if="item.status.valor==4">{{ item.status.descr }}</span>
                        </td>
                        <td>
                            <a @click="onEditManutencao(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="table-striped" id="mais">
                <thead>
                    <tr>
                        <th style="width: 100%">Observação</th>
                    </tr>
                 </thead>
                 <tbody>
                     <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_manutencao'>
                        <td>
                            <span>
                                {{ item.obs}}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div><!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t6'+rowData.veiculo_id+''" v-if="rowData.veiculo_multa.length>0">
        <table class="table-striped" id="mais">
            <thead>
                <tr>
                  <th data-toggle="true" style="width: 15%">N° Documento</th>
                  <th data-toggle="true" style="width: 15%">N° Multa</th>
                  <th data-toggle="true" style="width: 20%">Descrição</th>
                  <th data-toggle="true" style="width: 10%">Valor</th>
                  <th data-toggle="true" style="width: 15%">Data Multa</th>
                  <th data-toggle="true" style="width: 15%">Data Vencimento</th>
                  <th data-toggle="true" style="width: 5%">Status</th>
                  <th data-toggle="true" style="width: 5%">Ações</th>

                </tr>
             </thead>
             <tbody>
                 <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_multa'>
                    <td>
                     <span>{{ item.num_documento }}</span>
                    </td>
                    <td>
                        <span>{{ item.num_multa }}</span>
                    </td>
                    <td>
                     <span>{{ item.descr }}</span>
                    </td>
                    <td>
                        <span>{{ formatNumber(item.vlr_doc) }}</span>
                    </td>
                    <td>
                     <span>{{ formatDate(item.dt_multa) }}</span>
                    </td>
                    <td>
                     <span>{{ formatDate(item.dt_vencimento) }}</span>
                    </td>
                    <td>
                        <span class="label label-info" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                        <span class="label label-warning" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                        <span class="label label-success" v-if="item.status.valor==3">{{ item.status.descr }}</span>
                        <span class="label label-danger" v-if="item.status.valor==4">{{ item.status.descr }}</span>
                    </td>
                    <td>
                        <a @click="onEditMulta(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="table-striped" id="mais">
            <thead>
                <tr>
                    <th style="width: 100%">Observação</th>
                </tr>
             </thead>
             <tbody>
                 <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_multa'>
                    <td>
                        <span>
                            {{ item.obs}}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div><!--.tab-pane-->
    <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t7'+rowData.veiculo_id+''" v-if="rowData.veiculo_pneu.length>0">
    <table class="table-striped" id="mais">
        <thead>
            <tr>
              <th data-toggle="true" style="width: 5%">N° Série</th>
              <th data-toggle="true" style="width: 15%">Marca</th>
              <th data-toggle="true" style="width: 15%">Modelo</th>
              <th data-toggle="true" style="width: 10%">Eixo</th>
              <th data-toggle="true" style="width: 10%">Posição</th>
              <th data-toggle="true" style="width: 10%">Dimensão</th>
              <th data-toggle="true" style="width: 15%">KM Pneu</th>
              <th data-toggle="true" style="width: 15%">Data Instalação</th>
              <th data-toggle="true" style="width: 5%">Status</th>
              <th data-toggle="true" style="width: 5%">Ações</th>

            </tr>
         </thead>
         <tbody>
             <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_pneu'>
                <td>
                 <span>{{ item.num_serie }}</span>
                </td>
                <td>
                    <span>{{ item.marca }}</span>
                </td>
                <td>
                 <span>{{ item.modelo }}</span>
                </td>
                <td>
                    <span>{{ item.eixo.descr }}</span>
                </td>
                <td>
                    <span>{{ item.posicao.descr }}</span>
                </td>
                <td>
                    <span>{{ item.dimensao }}</span>
                </td>
                <td>
                    <span>{{ item.km_pneu }}</span>
                </td>
                <td>
                    <span>{{ formatDate(item.dt_instalacao) }}</span>
                </td>
                <td>
                    <span class="label label-warning" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                    <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                    <span class="label label-info" v-if="item.status.valor==3">{{ item.status.descr }}</span>
                </td>
                <td>
                    <a @click="onEditPneu(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                </td>
            </tr>
        </tbody>
    </table>
    <table class="table-striped" id="mais">
        <thead>
            <tr>
                <th style="width: 100%">Observação</th>
            </tr>
         </thead>
         <tbody>
             <tr class="bg-gray-light" style="display: table-row;" v-for='item in rowData.veiculo_pneu'>
                <td>
                    <span>
                        {{ item.obs}}
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
import { formatCNPJFromParts } from "../utils";

  import accounting from 'accounting'
  import moment from 'moment'
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onEditSeguro(data) {
            Event.$emit('editSeguro', data);
        },
        onEditAbastecimento(data) {
            Event.$emit('editAbastecimento', data);
        },
        onEditDocumento(data) {
            Event.$emit('editDocumento', data);
        },
        onEditManutencao(data) {
            Event.$emit('editManutencao', data);
        },
        onEditMulta(data) {
            Event.$emit('editMulta', data);
        },
        onEditPneu(data) {
            Event.$emit('editPneu', data);
        },
                onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
          return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatDate (value, fmt = 'D/MM/YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
  }
  }
  </script>